import {
  QuestionMarkCircleIcon,
  TrashCircleIcon,
  WarningCircleIcon,
} from "components/icons";
import ModalDialog from "components/ModalDialog";

import { useTranslationContext } from "context/TranslationContext";

interface ModalConfirmationProps {
  open: boolean;
  color?: "mustard" | "red" | "primary";
  title?: React.ReactNode;
  message?: React.ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  icon?: React.ReactNode;
  firstLineMessage?: string;
  secondLineMessage?: string;
  loading?: boolean;
  loadingCancel?: boolean;
  containerClassName?: string;
  onCancel?: () => void;
  onSubmit?: () => void;
}

const ModalConfirmation = ({
  open,
  color = "mustard",
  title,
  message,
  submitLabel,
  cancelLabel,
  icon,
  firstLineMessage,
  secondLineMessage,
  loading,
  loadingCancel,
  containerClassName,
  onCancel,
  onSubmit,
}: ModalConfirmationProps) => {
  const { t } = useTranslationContext();
  return (
    <ModalDialog
      open={open}
      submitLabel={submitLabel || t("leave")}
      cancelLabel={cancelLabel || t("stay")}
      disableClose
      submitBtnColor={color}
      cancelBtnColor={color}
      loading={loading}
      loadingCancel={loadingCancel}
      containerClassName={containerClassName}
      text={
        <div className="flex flex-col items-center gap-4">
          <div>
            {icon ? (
              icon
            ) : color === "mustard" ? (
              <WarningCircleIcon />
            ) : color === "primary" ? (
              <div className="text-primary-500">
                <QuestionMarkCircleIcon />
              </div>
            ) : (
              <TrashCircleIcon />
            )}
          </div>
          <div className="text-lg font-semibold">
            {title || t("unsaved_changes")}
          </div>
          <div className="text-base w-[85%]">
            {message || (
              <>
                {firstLineMessage || t("component.modal_confirmation.message1")}
                <br />
                {secondLineMessage ||
                  t("component.modal_confirmation.message2")}
              </>
            )}
          </div>
        </div>
      }
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  );
};

export default ModalConfirmation;
